import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const TOKEN_KEY = "esvan_token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Premium gating: a 402 means the ESVAN trial ended without an active subscription.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402 && typeof window !== "undefined") {
      if (!window.location.pathname.startsWith("/subscription")) {
        window.location.assign("/subscription?locked=1");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  // Never surface a raw serialized object ("[object Object]") to the user.
  if (detail && typeof detail === "object") return "";
  return String(detail);
}

// Translate a structured backend error ({code, message}) via i18n, with fallbacks.
export function apiError(err, t) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && !Array.isArray(d) && d.code && t) {
    const key = `errors.${d.code}`;
    let translated = t(key);
    if (translated && translated !== key) {
      if (d.minutes != null) translated = translated.replace("{n}", d.minutes);
      return translated;
    }
  }
  const msg = formatApiErrorDetail(d);
  if (msg) return msg;
  return t ? t("errors.generic") : err?.message || "Something went wrong.";
}

export default api;
